import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <>
        <footer id="footer">
   

    <div className="container">
      <div className="copyright">
        &copy; Copyright <strong><span>Covid-19 Live Tracker</span></strong>. All Rights Reserved
      </div>
      <div className="credits">
      
      </div>
    </div>
  </footer>
  <Link to="#" className="back-to-top"><i className="icofont-simple-up"></i></Link>
            
        </>
    )
}

export default Footer;
